import { Cart } from "@/apps/shared/buyback/core/domain/model/Cart";
import buybackInCartBuilder from "@/apps/shared/buyback/core/infrastructure/mapper/buyback/buybackInCart/buybackInCartBuilder";
import customerInfoBuilder from "@/apps/dashboard/buyback/core/infrastructure/mapper/buyback/customerInfo/customerInfoBuilder";

class CartMapper {
  mapCartFromString(stringCart: string, minimumCartValue: number, maxNbOfItems: number): Cart {
    const parsedCart = JSON.parse(stringCart);

    const cartBuybacks = parsedCart.cartBuybacks.map((cb: any) => buybackInCartBuilder.buildFromParsedCartBuyback(cb));

    const builtCart = new Cart(parsedCart.cartId, cartBuybacks, maxNbOfItems, minimumCartValue);

    if (parsedCart.customerInfo) {
      builtCart.setCustomerInfo(customerInfoBuilder.buildFromParsedCustomerInfo(parsedCart.customerInfo));
    }
    if (parsedCart.customerIdentification) {
      builtCart.setCustomerIdentification(
        customerInfoBuilder.buildFromParsedCustomerIdentification(parsedCart.customerIdentification)
      );
    }

    return builtCart;
  }
}

export default new CartMapper();
